
window.theme = window.theme || {};

const fetchCart = async (url, data) => {
    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
};

theme.FetchAddToCart = {
    init: function() {
        const addToCartBtns = document.querySelectorAll('[data-fetch-add-to-cart]')

        for (let btn of addToCartBtns){
            btn.addEventListener('click', e => {
                const self = e.target
                const variantId = self.dataset.variantId;
                let data = {
                    'items': [{
                        'id': variantId,
                        'quantity': 1
                    }]
                };

                if (!variantId) return
                self.classList.add('btn--loading')
                const url = window.theme.routes.cartAdd ? window.theme.routes.cartAdd : '/cart/add.js'
                fetchCart(url, data)
                    .then(data => {
                        self.classList.remove('btn--loading')
                        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                            detail: {
                                product: data
                            }
                        }));
                    })
                    .catch(error => console.error('There has been a problem with your fetch operation:', error) );
            })
        }
    }
}

// Ajax add to cart
theme.FetchAddToCart.init();

// Accordion
const accordions = document.querySelectorAll('.js-accordion-legacy');
const toggleAccordion = e => {
    const self = e.target
    const content = self.nextElementSibling;
    self.classList.toggle('active');
    content.style.maxHeight ?
        content.style.maxHeight = null :
        content.style.maxHeight = `${content.scrollHeight + 100}px`;
}

accordions.forEach(accordion => {
    accordion.addEventListener('click', toggleAccordion, false);
});


const debounce = (f, delay) => {
  let timer = 0;
  return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => f.apply(this, args), delay);
  }
}

const reinitFlickitySlider = new ResizeObserver(debounce(([entry]) => {
  let flkty = Flickity.data(entry.target);
  if (flkty) flkty.resize();
}, 200));

const init = () => {
  const initSlider = elem => {
    new Flickity(elem, {
      freeScroll: true,
      contain: true,
      prevNextButtons: true, 
      pageDots: false,
      imagesLoaded: true
    });
  
    // Reinitializes flickity on resize
    reinitFlickitySlider.observe(elem);
  }

  const productSliders = document.querySelectorAll('.featured-collection-alt .product-slider .grid');
  productSliders.forEach(initSlider);
} 

document.addEventListener('DOMContentLoaded', init);


// Reinit flickity on window resize for Product Recommendations
document.addEventListener('recommendations:loaded', (e) => {
  const productRecommendations = document.querySelector('.product-recommendations-list');
  if (productRecommendations) reinitFlickitySlider.observe(productRecommendations);
})

// Simple countdown timer
const timers = document.querySelectorAll('.js-countdown-timer');

function getRemainingTime(endtime) {
  const total = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor( (total/1000) % 60 );
  const minutes = Math.floor( (total/1000/60) % 60 );
  const hours = Math.floor( (total/(1000*60*60)) % 24 );
  const days = Math.floor( total/(1000*60*60*24) );

  return {
    total,
    days,
    hours,
    minutes,
    seconds
  };
}

// Simple countdown timer
function updateClock(el, interval) {
  const timestamp = Date.parse(el.dataset.enddate);
  const endtime = new Date(`${el.dataset.enddate} GMT+10:00`);
  const t = getRemainingTime(endtime);
  const clock = el.querySelector('.clock');
  const daysSpan = clock.querySelector('.days');
  const hoursSpan = clock.querySelector('.hours');
  const minutesSpan = clock.querySelector('.minutes');
  const secondsSpan = clock.querySelector('.seconds');

  if (el.dataset.enddate == null || el.dataset.enddate == undefined || el.dataset.enddate == '') {
    console.log("No end date found. Please add an end date")
    return
  }

  // Update timestamp
  if (isNaN(timestamp) == false) {
    daysSpan.textContent = t.days;
    hoursSpan.textContent = t.hours;
    minutesSpan.textContent = t.minutes;
    secondsSpan.textContent = t.seconds;
  }
  else {
    console.log("Please enter a correct date format");
    return
  }

  // Close interval when timer goes 0
  if (t.total <= 0) clearInterval(interval);
}

if (timers) {
  timers.forEach(timer => {
    let timeinterval = setInterval(() => {updateClock(timer)},1000);
    updateClock(timer, timeinterval);
    timeinterval;
  })
}

// Final Sale Checkbox
window.addEventListener('DOMContentLoaded', () => {
  $(document).on('click', '.check-final-sale', (e) => {
    let btn = e.currentTarget;

    let wrapper = btn.closest('.cart__checkout-wrapper');

    let checkbox = wrapper.querySelector('.final-sale-checkbox__input');
    if (!checkbox) return;

    if (!checkbox.getAttribute('checked')) {
      e.preventDefault();
      alert('You must agree with the terms and conditions to proceed')
    }
  })

  $(document).on('click', '.final-sale-checkbox__input', (e) => {
    let checkbox = e.currentTarget;

    if (checkbox.hasAttribute('checked')) {
      checkbox.removeAttribute('checked');
    } else {
      checkbox.setAttribute('checked', true)
    }
  })

  // get discount parameter from URL for klaviyo checkout

  const searchParams = new URLSearchParams(window.location.search);

  if ( searchParams.has('discount') ) {
    let getDiscountCode = searchParams.get('discount');
    sessionStorage.setItem("discountcode", getDiscountCode);
  }

  if ( sessionStorage.getItem("discountcode") != null) {

    const checkoutForm = document.getElementById('CartPageForm');

    let discountParam = '/?discount=' + sessionStorage.getItem("discountcode");
    checkoutForm.action = checkoutForm.action + discountParam;
  }
})




function klaviyoSmile() {
	SmileUI.customerReady().then(customer => {
	  if (customer && customer.date_of_birth) {
          var date = new Date(customer.date_of_birth);

          var day = date.getDate();
          if (day < 10) {
            day = '0' + day;
          }

          var month = date.getMonth() + 1;
          if (month < 10) {
            month = '0' + month;
          }

          var dateFormat = date.getFullYear() + '-' + month + '-' + day;
		  
		  var klaviyo = window.klaviyo || [];
		  klaviyo.push(['identify', {
		    'email' : customer.email,
		    '$birthday' : dateFormat
		  }]);

	  } else {
	    // No customer was identified (user needs to log in or create an account)
	  }
	}).catch(err => {
	  // An error has occurred will trying to identify a customer
	});
} 

if (window.SmileUI) {
	klaviyoSmile();
} else {
  document.addEventListener('smile-ui-loaded', () => {
	  klaviyoSmile();
  });
}


document.addEventListener('cart:change', (e) => {
	document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} }));
})




